import { GA_DEFAULT_PAYLOAD } from 'Tracking/constants';

export const BE_ACCOMMODATIONS_LAYER_NAME = 'AdditionalAccommodationsLayer';
export const BE_CATEGORY_GA = 'bookingEngine';
export const BE_SAVE_VALIDATE_GA = 'validate';
export const BE_SAVE_REMOVE_GA = 'remove';
export const BE_SAVE_CLICK_GA = 'click';
export const BE_SHARE_ACTION = 'share-action';
export const BE_SAVE_ACTION = 'save-action';
export const BE_UNSAVE_ACTION = 'unsave-action';

export const BE_SAVE_CRITERIA_QUERY = 'openSaveConfirmationModal';
export const BE_SAVE_CRITERIA_NEW_ACCOUNT_QUERY = 'newAccount';

export const BOOKING_SELECTED_RESORT_ID = 'selectedProposalId';
export const BOOKING_QUERY_PARAMS = 'bookingQueryParams';
export const BOOKING_ENTRY_ROUTE = 'entryRoute';
export const STAFF_CHIEF_CODE = 'resort_chief';

export const BE_GA_DEFAULT_PAYLOAD = {
  ...GA_DEFAULT_PAYLOAD,
  categoryGA: BE_CATEGORY_GA,
  siteSection: 'Booking Engine',
};

export const CXO_STEP = {
  CONFIGURE: 'configure',
  AFFICHAGE: 'affichage',
  PAYMENT: 'payment',
};

export const CXO_STEP_GA = {
  configure: 'CXO_modifyFile',
  affichage: 'CXO_saveOption',
  payment: 'CXO_confirm',
};

export const PAGES = {
  ACTIVITIES: 'activities',
  BANKING: 'banking',
  ACCOMMODATION: 'accommodation',
  TRANSPORT: 'transport',
  SERVICES: 'services',
  PARTICIPANTS: 'participants',
  SUMMARY: 'summary',
};

export const CRITERIA_SELECTORS = {
  ATTENDEES: 'criteria-attendees',
  DEPARTURE: 'criteria-departure',
  PRODUCT: 'criteria-product',
  TRANSPORT: 'criteria-transport',
};

export const MULTI_SCHEDULE_RESORTS = ['TOMC_WINTER', 'SAOC_WINTER'];

export const PROSPECT_CUSTOMER = 'PROSPECT';

export const ORIGIN_PLE = 'ple';

export const SUBSCRIPTION_ORIGIN = {
  POPIN: 'POPIN',
  NEWSLETTER: 'NEWSLETTER',
  CUSTOMER_ACCOUNT: 'CUSTOMER_ACCOUNT',
};

export const POOL_HEATING_DESCRIPTION = 'POOL_HEATING_DESCRIPTION';

export const TRANSFER_TYPE_ENUM = Object.freeze({
  ROUND_TRIP: 'roundTrip',
  INBOUND: 'inbound',
  OUTBOUND: 'outbound',
});
export const DIFFERENT_STAY_SERVICES_IN_CART_ERROR = 'DIFFERENT_STAY_SERVICES_IN_CART';
